// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"594":"8142162af7d64fc1a1de","655":"c39524b616b392103187"}[chunkId] + ".js";
};